<template>
  <!-- ======================= -->
  <!-- TAB: POISON             -->
  <!-- (Artefact / DM view —   -->
  <!--  always fully editable) -->
  <!-- ======================= -->
  <div>
    <div class="row mt-2 mb-2"></div>
    <p class="bb-hdg mt-2 mb-3">Poison Details</p>
    <!-- ROW 1: poison type + potency -->
    <div class="row mt-2 mb-2">
      <div class="col-4 form-group">
        <div class="form-floating">
          <v-select
            :options="poisonTypes"
            :class="[
              'form-control',
              { 'is-invalid': errorFields.includes('poison_type') },
            ]"
            placeholder="select..."
            :modelValue="localItem.poison_type ?? activeItem.poison_type"
            @update:modelValue="onFieldChanged('poison_type', $event)"
            id="poison_type"
          >
            <template #search="{ attributes, events }">
              <input
                class="vs__search"
                v-bind="attributes"
                v-on="events"
              />
            </template>
          </v-select>
          <label
            class="bb-float-label optional"
            for="poison_type"
            >Poison Type</label
          >
        </div>
      </div>
      <div class="col-4 form-group">
        <CounterEmit
          :pass_ref="'pot'"
          :pass_label="'Potency'"
          :pass_count="localItem.pot ?? activeItem.pot ?? 0"
          :pass_min="0"
          :pass_max="100"
          :pass_digits="2"
          :invalid="errorFields.includes('pot')"
          @change="onFieldChanged('pot', $event.count)"
        />
      </div>
    </div>
    <!-- ROW 2: effect + delay -->
    <div class="row mt-2 mb-2">
      <div class="col form-group">
        <div class="form-floating">
          <input
            :class="[
              'form-control text-left',
              { 'is-invalid': errorFields.includes('effect') },
            ]"
            :value="localItem.effect ?? activeItem.effect"
            id="effect"
            @input="onFieldChanged('effect', $event.target.value)"
          />
          <label
            class="bb-float-label optional"
            for="effect"
            >Effect</label
          >
        </div>
      </div>
      <div class="col form-group">
        <div class="form-floating">
          <input
            :class="[
              'form-control text-left',
              { 'is-invalid': errorFields.includes('delay') },
            ]"
            :value="localItem.delay ?? activeItem.delay"
            id="delay"
            @input="onFieldChanged('delay', $event.target.value)"
          />
          <label
            class="bb-float-label optional"
            for="delay"
            >Delay</label
          >
        </div>
      </div>
    </div>
    <!-- ROW 3: damage dice + duration -->
    <div class="row mt-2 mb-2">
      <div class="col form-group">
        <div class="form-floating">
          <input
            :class="[
              'form-control text-left',
              { 'is-invalid': errorFields.includes('damage_dice') },
            ]"
            :value="localItem.damage_dice ?? activeItem.damage_dice"
            id="damage_dice"
            @input="onFieldChanged('damage_dice', $event.target.value)"
          />
          <label
            class="bb-float-label optional"
            for="damage_dice"
            >Damage Dice</label
          >
        </div>
      </div>
      <div class="col form-group">
        <div class="form-floating">
          <input
            :class="[
              'form-control text-left',
              { 'is-invalid': errorFields.includes('duration') },
            ]"
            :value="localItem.duration ?? activeItem.duration"
            id="duration"
            @input="onFieldChanged('duration', $event.target.value)"
          />
          <label
            class="bb-float-label optional"
            for="duration"
            >Duration</label
          >
        </div>
      </div>
    </div>
    <!-- ROW 4: resist -->
    <div class="row mt-2 mb-2">
      <div class="col-6 form-group">
        <div class="form-floating">
          <input
            :class="[
              'form-control text-left',
              { 'is-invalid': errorFields.includes('resist') },
            ]"
            :value="localItem.resist ?? activeItem.resist"
            id="resist"
            @input="onFieldChanged('resist', $event.target.value)"
          />
          <label
            class="bb-float-label optional"
            for="resist"
            >Resist</label
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CounterEmit from './CounterEmit.vue'

export default {
  name: 'ArtefactPoisonTab',
  components: {
    CounterEmit,
  },
  props: {
    activeItem: {
      type: Object,
      required: true,
    },
    localItem: {
      type: Object,
      required: true,
    },
    onFieldChanged: {
      type: Function,
      default: () => {},
    },
    poisonTypes: {
      type: Array,
      default: () => [],
    },
    errorFields: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
